import React, { useState, useEffect } from 'react';
import { FaAngleLeft, FaAngleRight, FaEye, FaEdit, FaTag , FaUndo , FaFilter } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import { getSecuritiesByIssuerAccountId, getSecurityById } from '../service/api/SecurityService';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import useSelectedDomain from '../service/Hooks/useSelectedDomain';
import { useUserData } from '../service/api/useUserData';

const ClientSecuritiesList = () => {
    // gerer le domain
  const selectedDomain = useSelectedDomain();
  const [securities, setSecurities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const { getUserInfo } = useUserData(); // Utilisation du service
  const [issuerAccountId, setIssuerAccountId] = useState(null); // Ajout de l'état issuerAccountId
  const [filteredSecurities, setFilteredSecurities] = useState([]);
//   view more
  const [showModal, setShowModal] = useState(false);
  const [selectedSecurityId, setSelectedSecurityId] = useState(null);
  const [securityDetails, setSecurityDetails] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
 
  const [selectedType, setSelectedType] = useState(''); // State for selected type filter

  const pageSize = 6;


//   recuperer l'id de accountId

  useEffect(() => {
    async function fetchUserData() {
      const userInfo = await getUserInfo();
      if (!userInfo) return;
      const { accountId } = userInfo;
      
      setIssuerAccountId(accountId); // Stockage de accountId dans l'état
    }
    fetchUserData();
  }, []);

  

  useEffect(() => {
    if(!selectedDomain || !selectedDomain.id){
        return; 
    }
    if (!issuerAccountId) return; // Ne pas récupérer les securities si issuerAccountId est null

    const fetchSecurities = async () => {
      setIsLoading(true);
      try {
        const data = await getSecuritiesByIssuerAccountId(issuerAccountId, selectedDomain.id, currentPage, pageSize);
        setSecurities(data);
        setFilteredSecurities(data); // Initial filtered securities
        setTotalPages(Math.ceil(data.length / pageSize));
      } catch (error) {
        console.error('Erreur lors de la récupération des securities :', error);
        toast.error('Erreur lors de la récupération des securities.');
        setSecurities([]);
        setFilteredSecurities([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSecurities();
  }, [issuerAccountId, selectedDomain, currentPage, pageSize]);

//   gerer le filtre  // Handle type filtering
  const handleFilterChange = (event) => {
    const type = event.target.value;
    setSelectedType(type);
    filterSecurities(type);
  };

  const filterSecurities = (type) => {
    if (type) {
      const filtered = securities.filter(security => security.type === type);
      setFilteredSecurities(filtered);
      setTotalPages(Math.ceil(filtered.length / pageSize));
      setCurrentPage(1); // Reset to page 1 when filter is applied
    } else {
      setFilteredSecurities(securities); // No filter
      setTotalPages(Math.ceil(securities.length / pageSize));
    }
  };

  // Handle reset filter
  const resetFilter = () => {
    setSelectedType('');
    setFilteredSecurities(securities);
    setTotalPages(Math.ceil(securities.length / pageSize));
    setCurrentPage(1); // Reset to page 1
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getDisplayedRange = () => {
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, securities.length);
    return `${start}-${end}`;
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
          <a className="page-link" href="javascript:void(0)" onClick={() => goToPage(i)}>
            {i}
          </a>
        </li>
      );
    }
    return pageNumbers;
  };

  const displayedSecurities = securities.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Tooltips for icons
  const renderTooltip = (message) => (
    <Tooltip id="tooltip">{message}</Tooltip>
  );

  // Get unique types for the filter
  const getUniqueTypes = () => {
    const types = [...new Set(securities.map(security => security.type))];
    return types;
  };

  

//   pour view more 
const handleShowModal = (id) => {
    setSelectedSecurityId(id);
    setShowModal(true);
};

const handleCloseModal = () => {
    setShowModal(false);
    setSecurityDetails(null);
};

useEffect(() => {
    if (selectedSecurityId) {
    const fetchSecurityDetails = async () => {
        try {
        const details = await getSecurityById(selectedSecurityId);
        setSecurityDetails(details);
        } catch (error) {
        console.error("Erreur lors de la récupération des détails de la security :", error);
        }
    };
    fetchSecurityDetails();
    }
}, [selectedSecurityId]);



  return (
    <div className="container mt-4">
        
      {isLoading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <>
          <div className="row">
            {displayedSecurities.length === 0 ? (
              <p className="text-center text-muted text-danger">Aucun titre trouvée.</p>
            ) : (
              displayedSecurities.map((security) => (
                <div key={security.id} className="col-xl-4 col-lg-6 col-md-6 mb-4">
                  <div className="card shadow-sm rounded-3">
                    <div className="card-body">
                      <div className="dlab-info">
                        <h5 className="mb-2">{security.name}</h5>
                        <p className="m-0">
                          <strong>Type: </strong>
                          <a href="#" className="text-primary">{security.type || "N/A"}</a>
                        </p>
                        <p className="m-0"><strong>ISIN: </strong>{security.isin || "N/A"}</p>
                        <p className="m-0"><strong>Symbol: </strong>{security.symbol || "N/A"}</p>
                        <p className="m-0"><strong>Coupon Rate: </strong>{security.couponRate || "N/A"}%</p>
                        <p className="m-0"><strong>Creation Date: </strong>{new Date(security.creationDate).toLocaleDateString()}</p>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <span className="text-muted">
                            <span className="fw-bold text-success fs-5">
                              {security.issuePrice ? `$${security.issuePrice.toFixed(2)}` : "N/A"}
                            </span>
                            <div className="d-flex align-items-center">
                              
                              <OverlayTrigger placement="top" overlay={renderTooltip('Price Tag')}>
                                <button className="btn btn-link p-0 ms-2" style={{ fontSize: '1.25rem', color: '#007bff' }}>
                                  <FaTag />
                                </button>
                              </OverlayTrigger>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer text-end">
                      <OverlayTrigger placement="top" overlay={renderTooltip('View More Details')}>
                        <a href='#'
                          className="btn btn-link p-0 " style={{ fontSize: '1.5rem', color: '#007bff' }}
                          onClick={(e) => {
                          e.preventDefault();
                          handleShowModal(security.id);
                        }} >
                          <FaEye />
                        </a>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="table-pagination px-4">
            <p>
              Showing <strong className="text-primary me-1">{getDisplayedRange()}</strong> from{' '}
              <strong className="text-primary me-1">{securities?.length || 0}</strong> data
            </p>
            <nav>
              <ul className="pagination pagination-gutter pagination-primary no-bg">
                <li className="page-item page-indicator">
                  <a className="page-link" href="javascript:void(0)" onClick={() => goToPage(currentPage - 1)}>
                    <FaAngleLeft />
                  </a>
                </li>
                {renderPageNumbers()}
                <li className="page-item page-indicator">
                  <a className="page-link" href="javascript:void(0)" onClick={() => goToPage(currentPage + 1)}>
                    <FaAngleRight />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}

      {/* Modal pour le view more*/}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>details of your securities</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {securityDetails ? (
            <div className="p-4 rounded shadow">
              <h4 className="mb-4 text-primary">{securityDetails.name}</h4>

              <div className="row">
                {/* Informations générales */}
                <div className="col-md-6 mb-3">
                  <strong>Symbol:</strong> <span className="ms-2">{securityDetails.symbol || "N/A"}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>ISIN:</strong> <span className="ms-2">{securityDetails.isin || "N/A"}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Type:</strong> <span className="ms-2">{securityDetails.type || "N/A"}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Target Market:</strong> <span className="ms-2">{securityDetails.targetMarket || "N/A"}</span>
                </div>

                {/* Informations financières */}
                <div className="col-md-6 mb-3">
                  <strong>Issue Price:</strong> <span className="ms-2">{securityDetails.issuePrice ? `$${securityDetails.issuePrice.toFixed(2)}` : "N/A"}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Coupon Rate:</strong> <span className="ms-2">{securityDetails.couponRate || "N/A"}%</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Coupon Frequency:</strong> <span className="ms-2">{securityDetails.couponFrequency || "N/A"}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Total Units Issue:</strong> <span className="ms-2">{securityDetails.totalUnitsIssue || "N/A"}</span>
                </div>

                {/* Informations du propriétaire et de la date */}
                <div className="col-md-6 mb-3">
                  <strong>Issuer Account Name:</strong> <span className="ms-2 text-primary">{securityDetails.accountFirstname || "N/A"}{securityDetails.accountLastname}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Creation Date:</strong> <span className="ms-2">{securityDetails.creationDate ? new Date(securityDetails.creationDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : "N/A"}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Repayable:</strong>
                  <span className={`ms-2 ${securityDetails.repayable ? 'text-success' : 'text-danger'}`}>
                    {securityDetails.repayable ? '(YES) Refundable' : '(NO) Non refundable'}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <p>Chargement des détails...</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ClientSecuritiesList;
